module.exports = __webpack_public_path__ + "static/img/servicecenter__bg-tablet.c7fe1669.svg";